import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/index.js';
export const ReadBillByIdApiSchema = {
    params: z.object({
        entityId: CornSchema,
        billId: z.string(),
    }),
    response: z.object({ bill: BillSchema }),
};
export const ReadBillByIdPathSchema = ReadBillByIdApiSchema.params;
export const ReadBillByIdRequestSchema = ReadBillByIdPathSchema;
export const ReadBillByIdResponseSchema = ReadBillByIdApiSchema.response;
